import { type Chunkinator } from './domain';
import { getObservableFromFile } from './getObservableFromFile';

export const chunkinator: Chunkinator = (file, options, callbacks) => {
	return getObservableFromFile(file, options, callbacks);
};
